<template>

<div class="embed inner" v-html="item.code" />

</template>

<script>

export default {

    props: ['item']

}

</script>

<style scoped>

.embed >>> iframe {
    margin: 0px auto;
    max-width: 100%;
    display: block;
}

</style>
